// extracted by mini-css-extract-plugin
export default {"body":"createCustomScenarioModal_body__x8WAo","radio-group":"createCustomScenarioModal_radio-group__JhiPR","radio":"createCustomScenarioModal_radio__uI7bE"};